const initialState = {
    exam: undefined,
    examList: [],
    errors: {},
    isLoading: undefined
  }
  
  export default (state=initialState, action) => {
    switch(action.type) {
        case "GET_EXAM_SUCCESS":            
            return Object.assign({}, state, { examList: action.response })
        case "GET_EXAM_FAIL":
            return Object.assign({}, state, { errors: { getExamFail: "Falha ao adquirir a lista de exames"}})
        case "GET_PDF_START":
            return Object.assign({}, state, { isLoading: true })        
        case "GET_PDF_SUCCESS":
            return Object.assign({}, state, { isLoading: false })
        case "GET_PDF_FAIL":
            return Object.assign({}, state, { isLoading: false, errors: {status: 'Falha ao carregar o laudo'} })
        case "RESET_ERRORS":
            return Object.assign({}, state, {errors: {}})            
        default:
            return state
    }
  }